module.exports = __webpack_public_path__ + "img/icon-map.c10bc590.svg";